export default __webpack_public_path__ + "static/media/CNo.68-2.45c1b32f.jpg";